module.exports = __webpack_public_path__ + "img/image58.5c804f42.png";